import styled from "styled-components";

import colors from "core/colors";
import { A } from "core/Typography";

export const StyledSocialLink = styled(A)`
    &:focus {
        outline: 3px solid ${colors.focus};
    }
`;
